import React, { useEffect, useState } from 'react';
import axios from 'axios';
import GeneratorBase from './GeneratorBase';

const BusinessPostGenerator = () => {
  const [postingTimeSummary, setPostingTimeSummary] = useState('');

  useEffect(() => {
    const fetchPostingTime = async () => {
      try {
        const response = await axios.get('/api/posting-time/suggest');
        if (response.data.success && response.data.output) {
          const data = JSON.parse(response.data.output);
          const days = (data.bestDays || []).join(', ');
          const times = (data.bestTimes || [])
            .map(t => t.time)
            .join(' | ');
          if (days && times) {
            setPostingTimeSummary(`${days} — ${times}`);
          }
        }
      } catch (e) {
        // Fail silently; generator still works without posting time info
      }
    };

    fetchPostingTime();
  }, []);

  const fields = [
    {
      name: 'topic',
      label: 'Topic',
      type: 'text',
      placeholder: 'e.g., Digital Marketing Trends 2024',
      required: true
    },
    {
      name: 'keywords',
      label: 'Keywords',
      type: 'text',
      placeholder: 'e.g., digital marketing, branding, strategy',
      required: true
    },
    {
      name: 'tone',
      label: 'Tone',
      type: 'select',
      options: [
        { value: 'professional', label: 'Professional' },
        { value: 'friendly', label: 'Friendly' },
        { value: 'formal', label: 'Formal' }
      ],
      required: true
    },
    {
      name: 'targetAudience',
      label: 'Target Audience',
      type: 'text',
      placeholder: 'e.g., Marketing professionals, Small business owners',
      required: true
    }
  ];

  return (
    <GeneratorBase
      title="Business Post Generator"
      description="Create engaging LinkedIn business posts with strong hooks, valuable content, and clear CTAs. Perfect for B2World Branding marketing campaigns."
      fields={fields}
      apiEndpoint="business-post"
      saveDraftEndpoint="business-post"
      enableLinkedIn={true}
      postingTimeSummary={postingTimeSummary}
      
    />
  );
};

export default BusinessPostGenerator;
